<template>
  <div class="expandable-list-section-paragraph">
    <h2 v-if="paragraph.title" class="expandable-list-section-paragraph__title">
      {{ $t(paragraph.title) }}
    </h2>
    <p>{{ $t(paragraph.body) }}</p>
  </div>
</template>

<script>
import { TextParagraph } from '@/models/discover/TextParagraph';

export default {
  name: 'ExpandableListParagraph',
  props: {
    paragraph: {
      type: TextParagraph,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/expandable-list.scss';
</style>
